import { createFileRoute, redirect } from "@tanstack/react-router";
import { citySlug } from "@/utils/citySlug";

// Canonical city URL is /masini-de-vanzare-{city}.
export const Route = createFileRoute("/oras/$city/")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/masini-de-vanzare-${citySlug(params.city)}`, statusCode: 301 });
  },
});
